var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var Svg16 = function Svg16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.54 3.54a.65.65 0 0 1 .92 0l4 4a.65.65 0 0 1 0 .92l-4 4a.65.65 0 1 1-.92-.92L9.08 8 5.54 4.46a.65.65 0 0 1 0-.92Z",
    fill: "currentColor"
  })));
};

export { Svg16 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik01LjU0MDM5IDMuNTQwMzhDNS43OTQyMyAzLjI4NjU0IDYuMjA1NzggMy4yODY1NCA2LjQ1OTYzIDMuNTQwMzhMMTAuNDU5NiA3LjU0MDM4QzEwLjU4MTUgNy42NjIyOCAxMC42NSA3LjgyNzYxIDEwLjY1IDhDMTAuNjUgOC4xNzIzOSAxMC41ODE1IDguMzM3NzIgMTAuNDU5NiA4LjQ1OTYyTDYuNDU5NjMgMTIuNDU5NkM2LjIwNTc4IDEyLjcxMzUgNS43OTQyMyAxMi43MTM1IDUuNTQwMzkgMTIuNDU5NkM1LjI4NjU1IDEyLjIwNTggNS4yODY1NSAxMS43OTQyIDUuNTQwMzkgMTEuNTQwNEw5LjA4MDc3IDhMNS41NDAzOSA0LjQ1OTYyQzUuMjg2NTUgNC4yMDU3OCA1LjI4NjU1IDMuNzk0MjIgNS41NDAzOSAzLjU0MDM4WiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";